import './ellipsis-element.scss';

export function EllipsisElement({ children }) {
  return <div className="ellipsis-element">{children}</div>;
}
